export interface Origin {
  loanData: LoanData;
  instanceId: string;
  unisourceData: UnisourceData;
  company: Company;
  jwtToken: string;
}

export interface LoanData {
  property: Property;
  applications: Application[];
  loanCreationDate: string;
  id: string;
  extensions: Extensions;
  loanNumber: string;
  baseLoanAmount: number;
  purchasePriceAmount: number;
  mortgageType: string;
  organizationCode: string;
  requestedInterestRatePercent: number;
}

export interface Property {
  city: string;
  county: string;
  streetAddress: string;
  postalCode: string;
  state: string;
  loanPurposeType: string;
  propertyUsageType: string;
  financedNumberOfUnits: string;
}

export interface Application {
  borrower: Borrower;
  coborrower: Coborrower;
}

export interface Borrower {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  homePhoneNumber: string;
  mobilePhone: string;
  emailAddressText: string;
  maritalStatusType: string;
  employment: Employment[];
}

export interface Employment {
  phoneNumber: string;
}

export interface Coborrower {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  emailAddressText: string;
}

export interface Extensions {
  transactionId: string;
  transactionStatus: string;
}

export interface UnisourceData {
  isRestrictedUser: boolean;
  productTypes: ProductType[];
  documents: Documents;
  orders: Order[]
  primaryContacts: PrimaryContact[];
  endorsments: Endorsement[];
  questionSetting: QuestionSetting;
}

export interface ProductType {
  addOnProducts: any[];
  ancillaryProducts: any[];
  productType: string;
  productTypeID: number;
  transactionType: string;
  transactionTypeID: number;
}

export interface Documents {
  documents: any;
}

export interface PrimaryContact {
  partnerEmployeeID: number;
  partnerCompanyID: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface Endorsement {
  name: string;
  isSelected: boolean;
}

export interface QuestionSetting {
  isPayOffQuestions: boolean;
  isPolicyQuestions: boolean;
}

export interface Company {
  password: string;
  username: string;
}

export enum UnisourceRequestType {
  Order = 'Unisource Order',
  Fees = 'Unisource Fees',
  OrderUninsured = 'Unisource Order Uninsured',
  Documents = 'Encompass Documents',
  Nonbillable = 'Unisource Nonbillable',
}

//export enum TransactionStatus {
//  Failed = 3,
//  Canceled = 4,
//  OrderSubmited = 5,
//  FeesImported = 6,
//  Completed = 7
//}
export enum TransactionStatus {
  Pending = 'pending',
  Failed = 'failed',
  Cancelled = 'cancelled',
  UpdatingLoan = 'updating loan',
  Submited = 'ordersubmitted',
  FeesImported = 'fees imported',
  Completed = 'completed',
  Processing = 'processing',
}

export enum LogType
{
    Info = 1,
    Warning = 2,
    Error = 3 
}

export interface Status {
  orderNumber: string;
  orderAction: string;
  transactionId: string;
  partnerStatus: string;
  status: string;
  message: string;
  clientId: string;
  orderType: string;
  requestedBy: string;
  createdDate: string;
  updatedDate: string;
}

export interface Fees {
  amount: number;
  description: string;
  lineNumber: string;
  buyerAmount: number;
  aprAffectingFee: boolean;
  feeLineType: string;
  previousLineNumber: string;
  previousDescription: string;
  currentLineNumber: string;
  currentDescription: string;
  paidTo: string;
  payeeName: string;
  isSelected: boolean;
}

export interface Order {
  orderId: number;
  orderNumber: string;
  status: string;
  transactionId: string;
}

export interface UploadDocumentsResponse {
  orderId: number
  orderNumber: string
  transactionId: string
  documentId: string
  documentName: string
  documentStatus: string
  message: string;
  type: string
}

export enum UploadDocumentsStatus {
  Pending = 'Pending',
  Failed = 'Failed',
  Completed = 'Completed',
}

export interface FormStatus {
  orderNumber: string;
  transactionId: string;
  partnerStatus: any;
  status: string;
  message: string;
  clientId: string;
  orderType: string;
  orderAction: string;
  requestedBy: string;
  createdDate: string;
  updatedDate: string;
}
